export default `
<div id="page_content">
  <div class="page">
    <div class="liquor_licensing_laws">
      <p>
        New South Wales | Liquor Act 2007: No Alcohol can be sold or
        supplied to anyone under 18. It's against the law.
      </p>
      <p>
        ACT | Liquor Act 2010:It is an offence to supply alcohol to a person
        under the age of 18 years. Penalties apply.
      </p>
      <p>
        Victoria | Liquor Control Reform Act 1998:WARNING - Under the Liquor
        Control Reform Act 1998 it is an offence: To supply alcohol to a
        person under the age of 18 years [Penalty exceeds $19,000]; For a
        person under the age of 18 years to purchase or receive liquor
        [Penalty exceeds $800].
      </p>
      <p>
        Western Australia | Liquor Control Act 1988:WARNING - Under the
        Liquor Control Act 1988, it is an offence: to sell or supply liquor
        to a person under the age of 18 years on licensed or regulated
        premises; or for a person under the age of 18 years to purchase, or
        attempt to purchase, liquor on licensed or regulated premises.
      </p>
      <p>
        South Australia | Liquor Licensing Act 1997:Liquor must not be
        supplied to persons under 18.
      </p>
      <p>
        Queensland | Liquor Act 1992:It is an offence to supply liquor to a
        person under the age of 18 years.
      </p>
      <p>
        Tasmania | Liquor Licensing Act 1990: It is an offence for liquor to
        be delivered to a person under the age of 18 years. Penalty: Fine
        not exceeding 20 penalty units. It is an offence for a person under
        the age of 18 years to purchase liquor. Penalty: Fine not exceeding
        10 penalty units.
      </p>
    </div>
  </div>
</div>
`;
